module.exports = __webpack_public_path__ + "static/BakingBanner-03-506cca80f4120f6ad40fe397b883173f.png";